<template>
    <div class="registration-component" :class="{ 'mobile-view' : isMobileView, 'white-style': whitedRegForm }">
        <div v-show="!isAuth" class="rega-form">
            <slot></slot>

            <div class="rega-third-auth">
                <p class="form__login-tips">Продолжить в одно касание:</p>
                <third-auth-buttons></third-auth-buttons>
            </div>

            <p class="rega-tip">Или</p>

            <button class="button button-gradient show-rega-mobile" @click="showRegForm" v-show="!isShowForm">
                через e-mail
            </button>

            <button class="button button-colored show-rega-mobile" @click="showLoginForm" v-show="!isShowForm">
                я уже зарегистрирован
            </button>

            <form class="short_rega-form" @submit.prevent="reg" v-show="isShowForm && !isShowLoginForm">
                <div class="forms-wrap">
                    <div class="input-wrap">
                        <div class="form-field">
                            <input class="input" :name="form_id + '_rega_firstname'" autocomplete="off"
                                placeholder="Ваше имя" v-model="rega_firstname"
                                @input="clearErrors('firstname')" type="text" required>
                            <div class="error" :class="{ 'show': serverErrors.firstname }">
                                <p class="form-field__err">{{ serverErrors.firstname }}</p>
                            </div>
                        </div>
                        <div class="form-field">
                            <input class="input masked-phone" :id="form_id + '_rega_phone'"
                                :name="form_id + '_rega_phone'" autocomplete="off" placeholder="Мобильный телефон"
                                v-model="rega_phone" @input="clearErrors('phone')" type="tel" required>
                            <div class="error" :class="{ 'show': serverErrors.phone }">
                                <p class="form-field__err">{{ serverErrors.phone }}</p>
                            </div>
                        </div>
                        <div class="form-field">
                            <input class="input" :name="form_id + '_email'" autocomplete="off"
                                placeholder="Email" v-model="rega_email" @input="clearErrors('email')"
                                type="email" required>
                            <div class="error" :class="{ 'show': serverErrors.email }">
                                <p class="form-field__err">{{ serverErrors.email }}</p>
                            </div>
                        </div>
                    </div>
                    <button class="button button-gradient"
                        :class="{ highlighted: highlightRegButton }"
                        :disabled="isRegLoading" type="submit">
                        <slot name="buttontext">зарегистрироваться</slot>
                    </button>
                </div>
                <div class="form-addition-buttons">
                    <button class="button button-colored" type="button" @click="showLoginForm">
                        я уже зарегистрирован
                    </button>
                </div>
            </form>

            <div class="short_rega-form" v-show="isShowForm && isShowLoginForm">
                <form class="forms-wrap" @submit.prevent="sendEmailLink" v-show="isEmailLogin">
                    <div class="login-input-wrap">
                        <div class="form-field">
                            <input class="input" :name="form_id + '_login-email'" autocomplete="off"
                                   placeholder="Email" v-model="login_email" @input="clearErrors('loginEmail')"
                                   type="email" :id="form_id + '_login-email'" required>
                            <div class="error" :class="{ 'show': serverErrors.loginEmail }">
                                <p class="form-field__err">{{ serverErrors.loginEmail }}</p>
                            </div>
                        </div>
                        <p class="login-description">На почту будет отправлена временная ссылка для входа.</p>
                    </div>
                    <div class="login-buttons">
                        <button class="button button-gradient" :disabled="isLoginLoading" type="submit">
                            получить ссылку
                        </button>
                        <button class="button button-colored" type="button" @click="isEmailLogin = !isEmailLogin">
                            Войти с помощью телефона
                        </button>
                    </div>
                </form>
                <form class="forms-wrap" @submit.prevent="initPhoneLogin" v-show="!isEmailLogin">
                    <div class="login-input-wrap">
                        <div class="form-field">
                            <input class="input masked-phone" :id="form_id + '_login-phone'"
                                   :name="form_id + '_login-phone'" autocomplete="off" placeholder="Мобильный телефон"
                                   v-model="login_phone" @input="clearErrors('loginPhone')" type="tel" required>
                            <div class="error" :class="{ 'show': serverErrors.loginPhone }">
                                <p class="form-field__err">{{ serverErrors.loginPhone }}</p>
                            </div>
                        </div>
                        <p class="login-description">На указанный мобильный телефон придет СМС с кодом для входа.</p>
                    </div>
                    <div class="login-buttons">
                        <button class="button button-gradient" :disabled="isLoginLoading" type="submit">
                            Войти по СМС-коду
                        </button>
                        <button class="button button-colored" type="button" @click="isEmailLogin = !isEmailLogin">
                            Войти с помощью e-mail
                        </button>
                    </div>
                </form>
            </div>

            <div class="form-checkbox rega" v-if="privacyConfirmRequired">
                <input class="checkbox" :id="form_id + '_privacy'" type="checkbox" checked
                    v-model="rega_privacy" required :name="form_id + '_privacy'">
                <label :for="form_id + '_privacy'" class="label">
                    Оставляя контактные данные, вы соглашаетесь с <a href="/documents/privacy/"
                        target="_blank" class="privacy-link">политикой
                        конфиденциальности</a> и даете
                    согласние на обработку персональных данных, а также подтверждаете, что <a
                        href="/documents/eula/" target="_blank" class="privacy-link">Ознакомлены и согласны с
                        условиями Договора</a>
                </label>
            </div>

            <ul class="form-info-list">
                <li class="info-item">
                    <img class="info-icon" src="/img/svg/rega-percent-icon.svg" alt="" width="56" height="56"
                        loading="lazy">
                    <span class="info-text">Определим право на вычет и все доступные льготы для вас</span>
                </li>
                <li class="info-item">
                    <img class="info-icon" src="/img/svg/rega-clipboard-icon.svg" alt="" width="56"
                        height="56" loading="lazy">
                    <span class="info-text">Подготовим список необходимых документов</span>
                </li>
                <li class="info-item">
                    <img class="info-icon" src="/img/svg/rega-shield-icon.svg" alt="" width="56" height="56"
                        loading="lazy">
                    <span class="info-text">Исключим налоговые риски в виде штрафов и требований</span>
                </li>
            </ul>

            <!-- <div class="addition-wrap">
                <button class="button open-explanation" @click="showExplanation"
                    v-if="explanationEnabled && !isShowExplanation" type="button">
                    <img src="/img/svg/icon-how-we-works.svg" alt="" class="icon">
                    <span class="text">Как мы работаем</span>
                </button>

                <button class="button button-filled open-promo" @click="showPromoField"
                    v-if="promocodeEnabled && !isPromoFieldOpened">У меня есть промокод</button>
                <div class="form-field" v-if="promocodeEnabled && isPromoFieldOpened">
                    <input
                        class="input"
                        id="promocode"
                        autofocus
                        name="promocode"
                        autocomplete="off"
                        placeholder="Промокод"
                        v-model="promocode"
                        type="text">
                    <div class="form-field__success" v-if="promocode.length" style="display: none"></div>
                </div>
            </div> -->
        </div>

        <div class="auth-form" v-show="isAuth">
            <p class="auth-title">Вы уже зарегистрированы, подтвердите номер телефона</p>
            <form class="auth-columns" @submit.prevent="login">
                <div class="auth-column">
                    <p>Сейчас вы получите код в СМС на номер +7 {{ rega_phone | formatPhone }}</p>
                </div>
                <div class="auth-column">
                    <div class="form-field">
                        <input class="input" :name="form_id + '_code'" :id="form_id + '_code'"
                            autocomplete="off" v-model="code" inputmode="numeric" placeholder="Код из СМС"
                            @input="clearErrors('code')" maxlength="4" minlength="4" required type="tel">
                        <div class="error" :class="{ 'show': serverErrors.code }">
                            <p class="form-field__err">{{ serverErrors.code }}</p>
                        </div>
                    </div>
                </div>
                <div class="auth-column">
                    <button class="button button-gradient" :disabled="isRegLoading" type="submit">войти</button>
                    <p class="timer" v-show="timer">Получить новый код можно будет через {{ timer | formatTime }}</p>
                    <button class="button button-colored" v-show="!timer" @click="sendCode" type="button">
                        отправить код повторно
                    </button>
                </div>
            </form>
        </div>

        <Explanation class="explanation" :is-mobile-view="isMobileView"
            v-if="explanationEnabled && (isShowExplanation || (isDesktopScreen && !isTraderPage))" />
    </div>
</template>
  
<script>
import Inputmask from "inputmask";
import { api } from "../js/api";
import { Notice } from '../js/utils/notice';
import registrationHelper from '../js/utils/registrationHelper';
import Cookies from 'js-cookie';
import Explanation from './explanation.vue';
import ThirdAuthButtons from './ThirdAuthButtons.vue';

export default {
    name: 'Registration',

    components: {
        Explanation,
        ThirdAuthButtons
    },

    mixins: [
        registrationHelper
    ],

    props: {
        isTraderPage: {
            type: Boolean,
            default: false
        },
        isMobileView: {
            type: Boolean,
            default: false
        },
        explanationEnabled: {
            type: Boolean,
            default: true
        },
        promocodeEnabled: {
            type: Boolean,
            default: false
        },
        privacyConfirmRequired: {
            type: Boolean,
            default: false
        },
        highlightRegButton: {
            type: Boolean,
            default: false
        },
        isAutoOrder: {
            type: Boolean,
            default: true
        },
        registrationGoal: {
            type: String,
            default: ''
        },
        whitedRegForm: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            rega_email: '',
            rega_firstname: '',
            rega_phone: '',
            login_email: '',
            login_phone: '',
            rega_privacy: true,
            code: '',
            timer: 0,
            codeSent: false,
            codeSentTwice: false,
            isAuth: false,
            isPromoFieldOpened: false,
            isShowExplanation: false,
            isRegLoading: false,
            isLoginLoading: false,
            isShowForm: true,
            isShowLoginForm: false,
            isEmailLogin: true,
            stepsLink: '/declarations',
            promocode: '',
            serverErrors: {
                firstname: '',
                phone: '',
                email: '',
                code: '',
                loginEmail: '',
                loginPhone: ''
            },
            form_id: 'formId-' + Math.floor(Math.random() * 100000000),
            windowWidth: document.body.clientWidth
        };
    },

    computed: {
        isMobileScreen() {
            return this.windowWidth <= 767;
        },

        isDesktopScreen() {
            return this.windowWidth > 767;
        }
    },

    methods: {
        setMask() {
            const phoneInputs = document.querySelectorAll('.input.masked-phone');
            if (phoneInputs) {
                new Inputmask({
                    mask: "+7 (999) 999-99-99",
                    autoUnmask: true,
                    showMaskOnHover: false,
                    onBeforePaste: (pastedValue) => {
                        if (pastedValue.length > 10) {
                            pastedValue = pastedValue.slice(-10);
                        }
                        return pastedValue;
                    },
                }).mask(phoneInputs);
            }
        },

        onResize() {
            this.windowWidth = document.body.clientWidth;
        },

        reg() {
            if (this.rega_phone.length !== 10) {
                this.serverErrors.phone = 'Поле Мобильный телефон обязательно для заполнения.';
                document.querySelector('#' + this.form_id + '_rega_phone').focus();
                return;
            }

          if (this.privacyConfirmRequired && !this.rega_privacy) {
            new Notice().info('Для продолжения нужно принять условия сервиса', {
                timeout: 10000
            });
            return;
          }

            const body = Object.assign(this.getDefaultRegistrationParams(), {
                phone: '7' + this.rega_phone,
                firstname: this.rega_firstname,
                email: this.rega_email,
                not_add_autoorder: 1
            });

            // https://ndflka.ru/user/signup?ref=kamkombank
            if (location.search.indexOf('kamkombank') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'jcNpjKpVHM5fQnENe3We2mKxefRyuur6';
            }
            
            // https://ndflka.ru/user/signup?ref=sksoglasie
            if (location.search.indexOf('sksoglasie') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'NJL6486NcJpixE264n70skwZyHMZ45Qa';
            }

            // https://ndflka.ru/user/signup?ref=domclick
            if (location.search.indexOf('domclick') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'BjufRoGU7fysMulb5RuNji9KgF4iXwvs';
            }

            // https://ndflka.ru/user/signup?ref=cityxxi
            if (location.search.indexOf('cityxxi') !== -1) {
                api.defaults.headers['X-JTA-token'] = '9k2fiqsi46mbpc1refo6hnx6r5m2x4aw';
            }
            // https://ndflka.ru/user/signup?ref=thepie
            if (location.search.indexOf('thepie') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'fltvdctlolrg5t9hv5motk203tr5m4a2';
            }

            // https://ndflka.ru/user/signup?ref=bankzhilfin
            if (location.search.indexOf('bankzhilfin') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'gljlcaboyuc8jfj9t8eoefgxs6p3hrm3';
            }

            // https://ndflka.ru/user/signup?ref=hmcrdt
            if (location.search.indexOf('hmcrdt') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'z1W3~mFb3HS9PZjiwEiN';
            }

            // https://ndflka.ru/user/signup?ref=mydocs
            if (location.search.indexOf('mydocs') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'ladx41koar8l9nxggxqe9ru9dtvek1qe';
            }

            //https://ndflka.ru/user/signup?ref=rosnalog
            if (location.search.indexOf('rosnalog') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'OaXj4oZii3ZV8YrE4GEK'; 
            } 

            //https://ndflka.ru/user/signup?ref=rusnalog
            if (location.search.indexOf('rusnalog') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'w9ehv0kuubdd7ch8'; 
            }

            //https://ndflka.ru/user/signup?ref=nspk
            if (location.search.indexOf('nspk') !== -1) {
                api.defaults.headers['X-JTA-token'] = 'tACQIXmh9MzKWXbvQFVBZVyfMnZ4Khnc';
            }
            
            //https://ndflka.ru/user/signup?ref=faktura
            if (location.search.indexOf('faktura') !== -1) {
                api.defaults.headers['X-JTA-token'] = '9kd65jkmguho1l9trpht5ylwvylqq3bo';
            }

            this.isRegLoading = true;

            api.post('/user/shortReg', body)
            .then((res) => {
                const errors = res.data.errors;

                if (errors.hasOwnProperty('phone') && errors.phone) {
                    if (errors.phone[0] === 'Номер мобильного телефона уже зарегистрирован') {
                        this.sendCode(this.rega_phone);
                    } else {
                        this.serverErrors.phone = errors.phone[0];
                    }
                }

                if (errors.hasOwnProperty('firstname') && errors.firstname) {
                    this.serverErrors.firstname = errors.firstname[0];
                }

                if (errors.hasOwnProperty('email') && errors.email) {
                    this.serverErrors.email = errors.email[0];
                }

                if (res.data.data.hasOwnProperty('JWT')) {
                    Cookies.set('user_token', res.data.data.JWT, {expires: 3650, domain: process.env.COOKIE_DOMAIN, secure: true});

                    document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'reg_button' }}));
                    if (this.registrationGoal) {
                        document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': this.registrationGoal }}));
                    }

                    if (this.promocode) {
                        api.post('/promo/wish', { code: this.promocode })
                            .then((res) => {
                                const promocode = res.data;

                                if (promocode.discount_service.length === 1 && [3, 5, 8, 9, 23, 24, 25, 26, 27, 29, 30, 31, 33, 34, 36, 37, 38].includes(promocode.discount_service[0])) {
                                    this.createNewOrderWithPromocode(promocode.discount_service[0], promocode);
                                } else {
                                    location = this.stepsLink;
                                }
                            })
                            .catch(() => {
                                sessionStorage.setItem('promocode', '1');
                                location = this.stepsLink;
                            });

                    } else {
                        this.$emit('callback');
                    }

                    this.triggerPartsUpdate();
                }
            })
            .finally(() => {
                this.isRegLoading = false;
            });
        },

        showExplanation() {
            this.isShowExplanation = true;
        },

        showPromoField() {
            this.isPromoFieldOpened = true;
        },

        createNewOrderWithPromocode(serviceId, promocode) {
            api.post('/order', {sid: serviceId})
            .then(res => {
                let orderId = res.data.id;

                api.post('/promo/wish/activate', {wish_id: promocode.id, order_id: orderId})
                .then(() => {
                    api.post('/order/pay', {}, {params:{
                        id: orderId
                    }})
                    .then(() => {
                        location = '/declarations';
                    })
                    .catch(() => {
                        location = '/declarations';
                    });
                }).catch(() => {
                    location = '/declarations';
                });
            });
        },

        login() {
            const user = {
                phone: '7' + this.rega_phone,
                code: this.code,
                nid: localStorage.getItem('nanoId')
            };

            let ga_cid = Cookies.get('_ga');
            if (ga_cid) {
                user['ga_cid'] = ga_cid;
            }

            let ya_cid = Cookies.get('_ym_uid');
            if (ya_cid) {
                user['ya_cid'] = ya_cid;
            }

            this.isRegLoading = true;

            api.post('/user/auth', user)
                .then((res) => {
                    this.isRegLoading = false;
                    Cookies.set('user_token', res.data.token, {expires: 3650, domain: process.env.COOKIE_DOMAIN, secure: true});

                    this.$emit('callback');

                    this.triggerPartsUpdate();
                }).catch(() => {
                    this.serverErrors.code = 'Неверный код';
                    this.isRegLoading = false;
                });
        },

        sendCode(phone) {
            if (!phone) {
                phone = this.rega_phone;
            }
            return api.post('/user/sendcode', {phone: '7' + phone})
                .then(() => {
                    this.setTimerSendCode();
                    this.isAuth = true;

                    this.$nextTick(() => {
                        document.querySelector('#' + this.form_id + '_code').focus();
                    });
                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.data.code && err.response.data.code === 1) {
                            new Notice().error('Такой пользователь не найден', {
                                timeout: 10000
                            });
                        } else if (err.response.data) {
                            new Notice().error(err.response.data, {
                                timeout: 10000
                            });
                        }
                    } else {
                        new Notice().error('Произошла ошибка при отправке СМС', {
                            timeout: 10000
                        });
                    }
                });
        },
        
        triggerPartsUpdate() {
            document.dispatchEvent(new CustomEvent('headerGetProfile'));
        },

        setTimerSendCode() {
            this.timer = 60;
            let int = setInterval(() => {
                if (this.timer === 0) {
                    clearInterval(int);
                    return;
                }
                this.timer -= 1;
            }, 1000);
        },

        clearErrors(key) {
            if (this.serverErrors.hasOwnProperty(key)) {
              this.serverErrors[key] = '';
            }
        },

        showRegForm() {
            this.isShowForm = true;
            this.isShowLoginForm = false;
        },

        showLoginForm() {
            this.isShowForm = true;
            this.isShowLoginForm = true;
            this.$nextTick(() => {
                document.querySelector('#' + this.form_id + '_login-email').focus();
            });
        },

        checkInitialClientWidth() {
            this.isShowForm = document.body.clientWidth > 1000;
        },

        sendEmailLink() {
            if (this.privacyConfirmRequired && !this.rega_privacy) {
                new Notice().info('Для продолжения нужно принять условия сервиса', {
                    timeout: 10000
                });
                return;
            }

            const body = {
                email: this.login_email.toLowerCase(),
                redirect_uri: 'user/login'
            };

            this.isLoginLoading = true;
            this.clearErrors('loginEmail');

            api.post('/user/magicLink', body)
                .then(() => {
                    this.login_email = '';
                    this.isShowLoginForm = false;
                    new Notice().success('Ссылка отправлена на указанную почту', {
                        timeout: 10000
                    });

                    document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'email_login' }}));
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        this.serverErrors.loginEmail = err.response.data;
                    } else {
                        this.serverErrors.loginEmail = 'Произошла ошибка при входе по email';
                    }
                })
                .finally(() => {
                    this.isLoginLoading = false;
                });
        },

        initPhoneLogin() {
            if (this.privacyConfirmRequired && !this.rega_privacy) {
                new Notice().info('Для продолжения нужно принять условия сервиса', {
                    timeout: 10000
                });
                return;
            }

            if (this.login_phone.length !== 10) {
                this.serverErrors.loginPhone = 'Поле Мобильный телефон обязательно для заполнения.';
                document.querySelector('#' + this.form_id + '_login-phone').focus();
                return;
            }

            this.isLoginLoading = true;
            this.rega_phone = this.login_phone;
            this.sendCode(this.login_phone)
                .finally(() => {
                    this.isLoginLoading = false;
                });
        }
    },

    mounted() {
        this.setMask();
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });

        if (sessionStorage.getItem('open_promocode_input') && this.promocodeEnabled) {
            this.showPromoField();
            sessionStorage.removeItem('open_promocode_input');
        }

        this.checkInitialClientWidth();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }
};
</script>